import "./App.css";
import React from 'react'

import ContactMe from "pages/ContactMe";
import Header from "components/Header";
import Home from "pages/Home";

import { Routes, Route } from "react-router-dom";

function App() {
	return (
		<div className="App">
			<Header />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="kontakta-mig" element={<ContactMe />} />
			</Routes>
		</div>
	);
}

export default App;
